import { User } from "../types/User";

export function isSuperUser(user: User | undefined): boolean {
  if (user !== undefined && user.superUser) {
    return true;
  }
  return false;
}
